export default "__VITE_ASSET__DshC5yp8__"